import { Routes } from '@angular/router';
import { AppLayout } from '@/layout/components/app.layout';
import { Notfound } from '@/pages/notfound/notfound';
import { AuthLayout } from '@/layout/components/app.authlayout';
import { Oops } from '@/pages/oops/oops';
import { Access } from '@/auth/access';
import { authGuard, authChildGuard } from '@/core/auth.guard';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard],
        canActivateChild: [authChildGuard],
        children: [
            {
                path: '',
                loadChildren: () => import('@/pages/pages.routes')
                // data: { breadcrumb: 'Pages' }
            }
        ]
    },
    {
        path: 'auth',
        component: AuthLayout,
        children: [
            {
                path: 'login',
                loadComponent: () => import('@/auth/login').then((c) => c.Login)
            },
            {
                path: 'register',
                loadComponent: () => import('@/auth/register').then((c) => c.Register)
            },
            {
                path: 'verification',
                loadComponent: () => import('@/auth/verification').then((c) => c.Verification)
            },
            {
                path: 'forgot-password',
                loadComponent: () => import('@/auth/forgotpassword').then((c) => c.ForgotPassword)
            },
            {
                path: 'new-password',
                loadComponent: () => import('@/auth/newpassword').then((c) => c.NewPassword)
            },
            {
                path: 'lock-screen',
                loadComponent: () => import('@/auth/lockscreen').then((c) => c.LockScreen)
            }
        ]
    },
    { path: 'notfound', component: Notfound },
    { path: 'access-denied', component: Access },
    { path: 'oops', component: Oops },
    { path: '**', redirectTo: '/notfound' }
];
